import React from 'react';
import { IconProps } from '../types';

interface CustomIconProps extends IconProps {
  viewBox?: string;
  role?: string;
  'aria-hidden'?: boolean;
}

export const SsfRulerOn = React.memo<CustomIconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
    width,
    height,
    role = 'img',
    'aria-hidden': ariaHidden = false,
  }) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      className={className}
      onClick={onClick}
      role={role}
      aria-hidden={ariaHidden}
      style={{ cursor: onClick ? 'pointer' : 'inherit' }}
    >
      <path
        d="M17 6C17.5523 6 18 6.44772 18 7V13C18 13.5523 17.5523 14 17 14H3C2.44772 14 2 13.5523 2 13V7C2 6.44772 2.44772 6 3 6H17ZM4.45215 7L4.39844 11C4.39846 11.3312 4.66687 11.5994 4.99805 11.5996C5.3294 11.5996 5.59861 11.3314 5.59863 11V8.2002H6.89844V9.7998C6.89844 10.131 7.16686 10.4002 7.49805 10.4004C7.82942 10.4004 8.09863 10.1312 8.09863 9.7998V8.2002H9.39844V11C9.39846 11.3312 9.66687 11.5994 9.99805 11.5996C10.3294 11.5996 10.5986 11.3314 10.5986 11V8.2002H11.8984V9.7998C11.8984 10.131 12.1668 10.4002 12.498 10.4004C12.8294 10.4004 13.0986 10.1312 13.0986 9.7998V8.2002H14.3984V11C14.3985 11.3312 14.6668 11.5994 14.998 11.5996C15.3294 11.5996 15.5986 11.3314 15.5986 11V7H4.45215Z"
        fill="white"
      />
    </svg>
  ),
);

SsfRulerOn.displayName = 'SsfRulerOn';
